/**
 * Project Risk (RAG) rating — single source of truth.
 *
 * Simple Red / Amber / Green health flag per project. Set by operators
 * on the New/Edit project modals; surfaced on the Investor Dashboard
 * (summary chips, per-row badge, multi-select filter).
 */

export const DEFAULT_RISK = "green";

export const RISK_STATUSES = [
  { key: "red",   label: "Red",   sub: "At risk",     tone: "#C0362C" },
  { key: "amber", label: "Amber", sub: "Watch",       tone: "#B8721E" },
  { key: "green", label: "Green", sub: "On track",    tone: "#0F8B84" },
];

export const RISK_KEYS = RISK_STATUSES.map((r) => r.key);

export const RISK_BY_KEY = Object.fromEntries(
  RISK_STATUSES.map((r) => [r.key, r])
);

/** Coerce arbitrary input to a known risk key, defaulting to green. */
export function resolveRisk(value) {
  if (!value) return DEFAULT_RISK;
  const v = String(value).toLowerCase().trim();
  return RISK_BY_KEY[v] ? v : DEFAULT_RISK;
}

/** Return the tone (hex) for a given risk key. */
export function riskTone(key) {
  return (RISK_BY_KEY[key] || RISK_BY_KEY[DEFAULT_RISK]).tone;
}
